import {yupResolver} from "@hookform/resolvers/yup";
import {Box, Button, Grid, IconButton, Menu, Tooltip, Typography, Paper, Chip, useMediaQuery, useTheme} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import managerLessonApi from "api/managerLesson";
import {useAppDispatch, useAppSelector} from "app/hooks";
import EMOJI from "assets/img/emoji.png";
import ICON_DISLIKE from "assets/img/icon_dislike.png";
import ICON_LIKE from "assets/img/icon_like.png";
import LOADING from "assets/img/loading.gif";
import ControlVideo from "components/ControlVideo";
import InputField from "components/FormFields/InputField";
import Picker, {SKIN_TONE_MEDIUM_DARK} from "emoji-picker-react";
import LOGO from "assets/img/logo.png";
import {
  fetchLessonList,
  selectFilterLessonListPosted,
  selectLoadingLessonList,
} from "features/Admin/pages/ManagerLesson/managerLessonSlice";
import {useConfirm} from "material-ui-confirm";
import {ResponseStatus} from "models/common";
import {Comment, LessonByUser, ListResponseComments} from "models/managerLesson";
import React, {ChangeEvent, Fragment, useCallback, useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import ReactPlayer from "react-player";
import {useNavigate, useParams} from "react-router-dom";
import {toast} from "react-toastify";
import * as yup from "yup";
import ListComment from "./components/ListComment";
import ListVideoRecommend from "./components/ListVideoRecommend";
import useStyles from "./style";

let count = 0;

export default function DetailLesson() {
  const [openDrawer, setOpenDrawer] = useState(true);
  const {t} = useTranslation();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const schema = yup.object().shape({
    comment: yup.string().required(`${t("home.detaillesson.vuilongnhapbinhluan")}`),
  });
  const [comment, setComment] = useState("");
  const [openEmoji, setOpenEmoji] = useState<null | HTMLElement>(null);
  const [detailLesson, setDetailLesson] = useState<LessonByUser | undefined>();
  const params = useParams();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const dispatch = useAppDispatch();
  const filterListPosted = useAppSelector(selectFilterLessonListPosted);
  const loading = useAppSelector(selectLoadingLessonList);
  const [openButton, setOpenButton] = useState(false);
  const [listComment, setListComment] = useState<ListResponseComments<Comment> | undefined>();
  const [filter, setFilter] = useState({
    page: 0,
    size: 3,
  });

  const playerWrapperRef = useRef<any>(null);
  const playerRef = useRef<any>(null);
  const controlsRef = useRef<any>(null);

  const [showControl, setShowControl] = useState(false);
  const [control, setControl] = useState({
    played: 0,
    muted: false,
    volume: 1,
    playbackRate: 1.0,
    playing: true,
    start: false,
  });

  const handleFetchListComment = useCallback(async () => {
    try {
      const res: ListResponseComments<Comment> = await managerLessonApi.getComments({
        page: 0,
        size: 3,
        lessionId: Number(params.id),
      });
      setListComment(res);
    } catch (error) {}
  }, [params]);

  const handleFetchDetailLesson = useCallback(async () => {
    try {
      const res: LessonByUser = await managerLessonApi.getDetailLessonByUser(Number(params.id));
      setDetailLesson(res);
    } catch (error) {}
  }, [params]);

  useEffect(() => {
    handleFetchDetailLesson();
    handleFetchListComment();
    setFilter({page: 0, size: 3});
  }, [params, handleFetchDetailLesson, handleFetchListComment]);

  useEffect(() => {
    dispatch(fetchLessonList(filterListPosted));
  }, [dispatch, filterListPosted]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const initialValues = {
    comment: "",
  };
  const {control: formControl, handleSubmit, setValue, getValues, reset} = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleOpenEmoji = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenEmoji(event.currentTarget);
  };

  const onEmojiClick = (event: any, emojiObject: any) => {
    setValue("comment", getValues().comment + emojiObject.emoji);
    setComment(emojiObject.emoji);
  };

  const classes = useStyles({
    comment,
  });

  const handleShowMore = async () => {
    setFilter({...filter, page: filter.page + 1});
    try {
      const res: ListResponseComments<Comment> = await managerLessonApi.getComments({
        ...filter,
        lessionId: Number(params.id),
        page: filter.page + 1,
      });
      if (res && listComment) {
        setListComment({
          ...res,
          comments: {
            ...res.comments,
            content: [...listComment.comments.content, ...res.comments.content],
          },
        });
      }
    } catch (error) {}
  };

  const handleSubmitComment = async (values: any) => {
    try {
      const res: ResponseStatus = await managerLessonApi.postComment({
        comment: values.comment,
        lessionId: Number(params.id),
      });
      if (res.responseCode === "00") {
        reset();
        setComment("");
        setOpenButton(false);
        handleFetchListComment();
        toast.success(`${t("home.detaillesson.binhluanthanhcong")}`);
      }
    } catch (error) {}
  };

  const handlePostLikeStatus = async (lesson?: LessonByUser) => {
    const likeStatus =
      lesson?.lessionUsers?.likeStatus === "LIKED"
        ? "NONE"
        : "LIKED";
    try {
      const res: ResponseStatus = await managerLessonApi.postLikeStatus({
        likeStatus,
        lessionId: Number(params.id),
      });
      if (res.responseCode === "00") {
        handleFetchDetailLesson();
      }
    } catch (error) {}
  };

  const handlePostDislikeStatus = async (lesson?: LessonByUser) => {
    const likeStatus =
      lesson?.lessionUsers?.likeStatus === "DISLIKE"
        ? "NONE"
        : "DISLIKE";
    try {
      const res: ResponseStatus = await managerLessonApi.postLikeStatus({
        likeStatus,
        lessionId: Number(params.id),
      });
      if (res.responseCode === "00") {
        handleFetchDetailLesson();
      }
    } catch (error) {}
  };

  const handleDeleteLesson = (lesson?: LessonByUser) => {
    confirm({
      title: (
        <Typography variant="h6" component="span" style={{fontWeight: "bold", fontSize: 20}}>
          {t("delete.xoabaihoc")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{color: "#004673"}}>
            {" "}
            {lesson?.lessionUsers?.lession?.lessionName}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}> {t("delete.dongy")}</Button>,
      cancellationText: <Button variant="outlined"> {t("delete.huybo")}</Button>,
    })
      .then(async () => {
        const res: ResponseStatus = await managerLessonApi.deleteLesson(
          lesson?.lessionUsers?.lessionId || Number(params.id)
        );
        if (res.responseCode === "00") {
          toast.success(`${t("managerLesson.xoabaihocthanhcong")}`);
          navigate(-1);
        } else {
          toast.error(`${t("managerLesson.xoabaihocthatbai")}`);
          throw new Error(res.responseDescription);
        }
      })
      .catch((error) => console.log(error));
  };

  const currentTime = playerRef && playerRef.current ? playerRef.current.getCurrentTime() : "00:00";
  const duration = playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";

  const handleToggleScreenfull = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (playerWrapperRef.current?.requestFullscreen) {
      playerWrapperRef.current.requestFullscreen();
    }
  };

  const handleMouseMove = () => {
    if (!controlsRef.current) return;
    controlsRef.current.style.visibility = "visible";
    count = 0;
  };

  const hanldeMouseLeave = () => {
    if (!controlsRef.current) return;
    controlsRef.current.style.visibility = "hidden";
    count = 0;
  };

  const handleProgress = (changeState: any) => {
    if (!controlsRef.current) return;
    if (count > 2) {
      controlsRef.current.style.visibility = "hidden";
      count = 0;
    }
    if (controlsRef.current.style.visibility === "visible") {
      count += 1;
    }
    setControl({ ...control, played: changeState.played });
  };

  const lessonObj = detailLesson?.lessionUsers?.lession;
  const isWatched = detailLesson?.lessionUsers?.watched ?? false;
  const pubDateStr = String(lessonObj?.publishDate || "");
  const day = pubDateStr.slice(-2);
  const month = pubDateStr.slice(4, 6);
  const year = pubDateStr.slice(0, 4);

  return loading ? (
    <Box className={classes.loading}>
      <img src={LOADING} alt="LOADING" />
    </Box>
  ) : (
    <Box className={classes.container}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBackIcon />}
        className={classes.backButton}
        onClick={() => navigate(-1)}
      >
        Quay lại
      </Button>

      <Grid container spacing={3}>
        {/* Left / Main Column */}
        <Grid item xs={12} lg={openDrawer ? 8 : 10}>
          {/* Sleek Player Frame */}
          <Paper className={classes.playerFrame} elevation={0}>
            <div
              className={classes.playerWrapper}
              ref={playerWrapperRef}
              onMouseMove={handleMouseMove}
              onMouseLeave={hanldeMouseLeave}
              onClick={() => setShowControl(true)}
            >
              {lessonObj?.attachment ? (
                <>
                  <ReactPlayer
                    onEnded={() => setControl({ ...control, playing: false })}
                    playsinline
                    playing={control.playing}
                    className={classes.reactPlayer}
                    url={lessonObj?.attachment?.url}
                    controls={false}
                    width="100%"
                    height="100%"
                    light={lessonObj?.attachment?.urlThumbnail}
                    playIcon={
                      <PlayArrowIcon
                        className={classes.playIconBtn}
                        onClick={() => setShowControl(true)}
                      />
                    }
                    ref={playerRef}
                    config={{ file: { attributes: { controlsList: "nodownload" } } }}
                    onContextMenu={(e: any) => e.preventDefault()}
                    muted={control.muted}
                    volume={control.volume}
                    playbackRate={control.playbackRate}
                    onProgress={handleProgress}
                    onStart={() => {
                      setControl({ ...control, start: !control.start });
                      const timer = detailLesson?.lessionUsers?.lastSeenTime;
                      if (timer && playerRef.current) {
                        playerRef.current.seekTo(timer, "seconds");
                      }
                    }}
                  />

                  {showControl && (
                    <ControlVideo
                      isWatched={isWatched}
                      playerRef={playerRef}
                      handleToggleScreenfull={handleToggleScreenfull}
                      ref={controlsRef}
                      setControl={setControl}
                      control={control}
                      currentTime={currentTime}
                      duration={duration}
                    />
                  )}
                </>
              ) : (
                <iframe
                  title="powerpoint-view"
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${lessonObj?.powerPointFileList?.[0]?.powerPointFile?.url}`}
                  width="100%"
                  height="450px"
                  style={{ border: "none" }}
                />
              )}
            </div>
          </Paper>

          {/* Lesson Details Card */}
          <Paper className={classes.infoCard} elevation={0}>
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" style={{ gap: 12 }}>
              <Box className={classes.categoryChip}>
                {lessonObj?.lessionCategory?.name || "BÀI HỌC CHUYÊN ĐỀ"}
              </Box>

              <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 10 }}>
                {isWatched ? (
                  <Chip
                    icon={<CheckCircleIcon style={{ color: "#16A34A", fontSize: 18 }} />}
                    label={t("home.detaillesson.daxem")}
                    variant="outlined"
                    style={{ borderRadius: 10, fontWeight: 700, borderColor: "#CBD5E1", color: "#16A34A" }}
                  />
                ) : (
                  <Chip
                    icon={<VisibilityIcon style={{ color: "#4F46E5", fontSize: 18 }} />}
                    label={t("home.detaillesson.chuaxem")}
                    variant="outlined"
                    style={{ borderRadius: 10, fontWeight: 700, borderColor: "#CBD5E1", color: "#4F46E5" }}
                  />
                )}

                <Tooltip
                  title={
                    detailLesson?.lessionUsers?.likeStatus === "LIKED"
                      ? `${t("home.detaillesson.bothich")}`
                      : `${t("home.detaillesson.khongthich")}`
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePostLikeStatus(detailLesson)}
                >
                  <Chip
                    icon={detailLesson?.lessionUsers?.likeStatus === "LIKED" ? <ThumbUpIcon style={{ color: "#0284C7", fontSize: 18 }} /> : <img src={ICON_LIKE} alt="LIKE" style={{ width: 16, height: 16 }} />}
                    label={`${lessonObj?.noUserLiked || 0} ${t("home.detaillesson.like")}`}
                    variant="outlined"
                    style={{ borderRadius: 10, fontWeight: 700, borderColor: "#CBD5E1" }}
                  />
                </Tooltip>

                <Tooltip
                  title={t("home.detaillesson.khongthich") || ""}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePostDislikeStatus(detailLesson)}
                >
                  <Chip
                    icon={detailLesson?.lessionUsers?.likeStatus === "DISLIKE" ? <ThumbDownIcon style={{ color: "#DC2626", fontSize: 18 }} /> : <img src={ICON_DISLIKE} alt="DISLIKE" style={{ width: 16, height: 16 }} />}
                    label={`${lessonObj?.noUserDislike || 0} ${t("home.detaillesson.unlike")}`}
                    variant="outlined"
                    style={{ borderRadius: 10, fontWeight: 700, borderColor: "#CBD5E1" }}
                  />
                </Tooltip>

                <Chip
                  icon={<DeleteIcon style={{ color: "#DC2626", fontSize: 18 }} />}
                  label={t("button.delete")}
                  variant="outlined"
                  onClick={() => handleDeleteLesson(detailLesson)}
                  style={{
                    borderRadius: 10,
                    fontWeight: 700,
                    borderColor: "#CBD5E1",
                    color: "#DC2626",
                    cursor: "pointer",
                  }}
                />
              </Box>
            </Box>

            <Typography className={classes.lessonTitle}>
              {lessonObj?.lessionName || "---"}
            </Typography>

            <Box className={classes.metaRow}>
              <Typography className={classes.dateText}>
                <CalendarTodayIcon style={{ fontSize: 16, color: "#64748B" }} />
                Ngày phát hành: {pubDateStr ? `${day}/${month}/${year}` : "---"}
              </Typography>
              <Typography style={{ color: "#64748B", fontSize: "0.85rem", fontWeight: 700 }}>
                Người đăng: <span style={{ color: "#0F172A", fontWeight: 800 }}>{lessonObj?.user?.name || "---"}</span>
              </Typography>
            </Box>

            <Typography className={classes.descTitle}>
              {t("home.detaillesson.mota")}:
            </Typography>
            <Typography className={classes.descContent}>
              {lessonObj?.lessionDescription || "Chưa có mô tả cho bài học này."}
            </Typography>
          </Paper>

          {/* Comments Section */}
          <Paper className={classes.commentSection} elevation={0}>
            <form onSubmit={handleSubmit(handleSubmitComment)}>
              <Box>
                <Typography variant="h6" style={{ fontSize: "1.0625rem", fontWeight: 800, color: "#0F172A", marginBottom: 16 }}>
                  {listComment?.comments.totalElements || 0} {t("home.detaillesson.binhluan")}
                </Typography>

                <Box mt={2} className={classes.root}>
                  <Box>
                    <img
                      src={lessonObj?.user?.profileImageUrl || LOGO}
                      alt="avatar"
                      className={classes.avatar}
                    />
                  </Box>
                  <Box position="relative" width="100%">
                    <InputField
                      name="comment"
                      label={t("home.detaillesson.vietbinhluan")}
                      onClick={() => setOpenButton(true)}
                      control={formControl}
                      onChange={(event: ChangeEvent<HTMLInputElement>) =>
                        setComment(event?.target.value)
                      }
                    />
                    <IconButton onClick={handleOpenEmoji} className={classes.icon_emoji}>
                      <img src={EMOJI} alt="EMOJI" />
                    </IconButton>
                    {openEmoji && (
                      <Menu
                        id="simple-menu"
                        anchorEl={openEmoji}
                        keepMounted
                        open={Boolean(openEmoji)}
                        onClose={() => setOpenEmoji(null)}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <Picker
                          onEmojiClick={onEmojiClick}
                          disableAutoFocus={true}
                          skinTone={SKIN_TONE_MEDIUM_DARK}
                          groupNames={{smileys_people: "PEOPLE"}}
                          native
                        />
                      </Menu>
                    )}
                  </Box>
                </Box>
                {openButton && (
                  <Box display="flex" justifyContent="flex-end" mt={2} style={{ gap: 8 }}>
                    <Button
                      onClick={() => {
                        setOpenButton(false);
                        reset();
                      }}
                      style={{ borderRadius: 10, fontWeight: 700 }}
                    >
                      {t("button.cancel")}
                    </Button>
                    <Button className={classes.btn__comment} type="submit" disabled={comment === ""}>
                      {t("home.detaillesson.binhluan")}
                    </Button>
                  </Box>
                )}
              </Box>
            </form>

            {/* List comment */}
            {listComment &&
              listComment.comments.content?.map((comment: Comment, index: number) => (
                <Fragment key={index}>
                  <ListComment
                    userComment={comment}
                    handleFetchListComment={handleFetchListComment}
                  />
                </Fragment>
              ))}
            {listComment?.comments?.number + 1 !== listComment?.comments?.totalPages &&
            listComment?.comments?.content &&
            listComment?.comments?.content?.length > 0 ? (
              <Box className={classes.showMoreBtn} onClick={handleShowMore} mt={3}>
                <ArrowDropDownIcon />
                <Typography variant="subtitle2">
                  {t("home.detaillesson.hienthithembinhluan")}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        </Grid>

        {/* Recommend Sidebar */}
        <Grid item xs={12} lg={openDrawer ? 4 : 2}>
          <ListVideoRecommend openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
          {!isTablet && (
            <Paper
              elevation={0}
              style={{
                marginTop: 20,
                borderRadius: 20,
                padding: 24,
                background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 100%)",
                color: "#FFFFFF",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.2)",
              }}
            >
              <Box display="flex" alignItems="center" style={{ gap: 8 }} mb={1.5}>
                <EmojiObjectsIcon style={{ color: "#FDE047", fontSize: 20 }} />
                <Typography style={{ fontWeight: 900, fontSize: "0.95rem", color: "#FDE047", letterSpacing: "0.02em" }}>
                  MẸO HỌC TẬP HIỆU QUẢ
                </Typography>
              </Box>

              <Typography style={{ fontSize: "0.85rem", color: "#CBD5E1", lineHeight: 1.6, marginBottom: 16 }}>
                Theo dõi đầy đủ video bài giảng và tham gia thảo luận bên dưới để hoàn thành chỉ tiêu học tập GPET Edu tháng này!
              </Typography>

              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: "#4F46E5",
                  color: "#FFFFFF",
                  fontWeight: 800,
                  borderRadius: 12,
                  textTransform: "none",
                  fontSize: "0.825rem",
                  padding: "10px 16px",
                  boxShadow: "0 4px 14px rgba(79, 70, 229, 0.4)",
                }}
                onClick={() => navigate("/admin/manager-student")}
              >
                Quản lý danh sách học viên
              </Button>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
